import { useState } from 'react';
import { updates, type Comic } from '@/mocks/comics';
import ComicCard from './ComicCard';
import SectionHeader from './SectionHeader';

interface UpdatesProps {
  onSelect: (comic: Comic) => void;
}

export default function Updates({ onSelect }: UpdatesProps) {
  const [active, setActive] = useState(0);
  const current = updates[active];

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeader
          kicker="每日更新"
          title="今日更新抢先看"
          desc="连载作品持续高频更新，热门题材每日上新，追更提醒让你不错过任何一话。"
        />

        <div className="flex flex-wrap gap-2 mb-6" role="tablist" aria-label="按题材筛选更新">
          {updates.map((u, i) => (
            <button
              key={u.label}
              type="button"
              role="tab"
              aria-selected={active === i}
              onClick={() => setActive(i)}
              className={`px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${
                active === i
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600 hover:bg-background-300'
              }`}
            >
              {u.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" role="tabpanel">
          {current.items.map((comic) => (
            <ComicCard key={`${active}-${comic.id}`} comic={comic} onSelect={onSelect} />
          ))}
        </div>
      </div>
    </section>
  );
}